import React from 'react';
import { IconProps } from './types';

const HeartBorderLight: React.FC<IconProps> = ({
  className,
  color = '#181B32',
  size = 32,
  ignoreColor,
}) => (
  <svg
    className={className}
    width={size * 1.125}
    height={size}
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      stroke={!ignoreColor ? color : undefined}
      d="M8.46932 2.60444L8.99953 3.13441L9.52974 2.60444C10.8455 1.28923 11.9888 0.75 13.0119 0.75C15.5665 0.75 17.2941 2.79267 17.2492 5.52017C17.2261 6.9176 16.198 8.63908 14.4906 10.4459C12.931 12.0963 10.9239 13.6943 8.99928 15.0092C7.06978 13.6941 5.05036 12.1106 3.48521 10.4686C1.7722 8.67149 0.75 6.95502 0.75 5.53252C0.75 2.80904 2.54373 0.75 5.11151 0.75C6.11822 0.75 7.13499 1.27071 8.46932 2.60444Z"
      strokeWidth="1.5"
    />
  </svg>
);

export default HeartBorderLight;
